import can from '../can'

class UrlBuilder {
    constructor(name, absolute, urlexObject) {
        this.name = name;
        this.urlex = urlexObject;
        this.route = this.urlex.namedRoutes[this.name];

        if (typeof this.name === 'undefined') {
            throw new Error('Urlex Error: You must provide a route name');
        } else if (typeof this.route === 'undefined') {
            throw new Error(`Urlex Error: route '${this.name}' is not found in the route list`);
        }

        this.absolute = typeof absolute === 'undefined' ? true : absolute;
        this.domain = this.setDomain();
        // if (!can(this.route.middleware)) {
        //     this.path = 'api/forbidden';
        // } else {
            this.path = this.route.uri.replace(/^\//, '');
        // }
    }

    setDomain() {
        if (!this.absolute)
            return '/';

        if (!this.route.domain)
            return this.urlex.baseUrl.replace(/\/?$/, '/');

        let host = (this.route.domain || this.urlex.baseDomain).replace(/\/+$/, '');

        if (this.urlex.basePort && (host.replace(/\/+$/, '') === this.urlex.baseDomain.replace(/\/+$/, '')))
            host = this.urlex.baseDomain + ':' + this.urlex.basePort;

        return this.urlex.baseProtocol + '://' + host + '/';
    }

    construct() {
        return this.domain + this.path
    }
}

export default UrlBuilder;
